import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'

const tasksSearchSchema = z.object({
  view: z.enum(['board', 'list', 'calendar']).optional(),
  // Assignee tab (read by TasksPage via nuqs). Declared here so deep-links
  // like /tasks?tab=me survive TanStack Router's search validation.
  tab: z.enum(['all', 'me', 'members', 'agents']).optional(),
  overdue: z.enum(['all', 'overdue']).optional(),
  resolved: z.enum(['all', 'active']).optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tasks',
)({
  validateSearch: tasksSearchSchema,
  staticData: { pageHeader: { title: 'Tasks', pad: false, scroll: false } },
})
